<template>
  <Breadcrumb :home="home" :model="items" class="custom-breadcrumb">
    <template #item="{ item }">
      <span
        @click="item?.command"
        :class="`${
          item?.command
            ? 'cursor-pointer hover:text-h-secondary-700 transition-all font-bold'
            : 'cursor-default'
        } capitalize`"
      >
        {{ item.label }}
      </span>
    </template>
  </Breadcrumb>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
export default defineComponent({
  name: "breadcrumb",
  props: {
    home: [Object],
    items: {
      type: Array as PropType<any>,
      default: [],
    },
  },
  methods: {
    capitalizeText(text: string): string {
      const replace = text.replaceAll("-", " ");
      return replace;
    },
  },
});
</script>
